import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import withSortableListItem from './withSortableListItem';

const styles = () => ({
  root: {
    position: 'relative',
  },
});

class SortableList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sortedItems: props.items.map(item => ({ ID: item.ID })),
      draggableData: {},
      dragged: false,
      timestamp: Date.parse(new Date()),
    };

    this.sortableItemComponent = withSortableListItem(props.itemComponent);

    this.onFieldDragStart = this.onFieldDragStart.bind(this);
    this.onFieldDrag = this.onFieldDrag.bind(this);
    this.onFieldDragStop = this.onFieldDragStop.bind(this);
    this.onDraggableDataChange = this.onDraggableDataChange.bind(this);
    this.onItemRemove = this.onItemRemove.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const currentItemsID = this.props.items.map(item => item.ID).join('-');
    const nextItemsID = nextProps.items.map(item => item.ID).join('-');
    if (currentItemsID !== nextItemsID) {
      this.setState({
        sortedItems: nextProps.items.map(item => ({ ID: item.ID })),
      });
    }
  }

  onDraggableDataChange(data) {
    this.setState({
      draggableData: {
        ...this.state.draggableData,
        ...data,
      },
    });
  }

  onFieldDragStart() {
    this.setState({ dragged: true });
  }

  onFieldDrag(data) {
    const { sortedItems, draggableData } = this.state;
    let moveDirectionY;
    if (Math.abs(data.defaultY - data.y) > 20) {
      moveDirectionY = data.y > data.defaultY ? 'bottom' : 'top';
    }
    const newSortedItems = sortedItems.map((item, index) => {
      if (index === data.index) {
        return {
          ...item,
          offsetY: 0,
        };
      }
      if (moveDirectionY === 'bottom') {
        if (index > data.index
          && draggableData[index] !== undefined
          && ((draggableData[index].height / 2) - draggableData[index].bounds.top)
          < (data.y + data.height)) {
          return {
            ...item,
            offsetY: -data.height,
          };
        }
      }
      if (moveDirectionY === 'top') {
        if (index < data.index
          && draggableData[index] !== undefined
          && ((draggableData[index].height / 2) - draggableData[index].bounds.top)
          > data.y) {
          return {
            ...item,
            offsetY: data.height,
          };
        }
      }
      return {
        ...item,
        offsetY: 0,
      };
    });
    this.setState({ sortedItems: newSortedItems });
  }

  onFieldDragStop(data) {
    const { sortedItems } = this.state;
    const newSortedItems = sortedItems.map(item => ({
      ...item,
      offsetY: 0,
    }));
    let newTimestamp = this.state.timestamp;
    let moveDirectionY;
    let moveIndex;
    if (Math.abs(data.defaultY - data.y) > 20) {
      moveDirectionY = data.y > data.defaultY ? 'bottom' : 'top';
    }
    if (moveDirectionY === 'top') {
      moveIndex = sortedItems.findIndex(item => item.offsetY);
    }
    if (moveDirectionY === 'bottom') {
      moveIndex = (sortedItems.length
        - [...sortedItems].reverse().findIndex(item => item.offsetY)) - 1;
    }
    if (moveIndex !== undefined) {
      newSortedItems.splice(moveIndex, 0, newSortedItems.splice(data.index, 1)[0]);
      newTimestamp = Date.parse(new Date());
      this.props.onSortingChange({
        sortedItems: newSortedItems,
      });
    }
    this.setState({
      dragged: false,
      sortedItems: newSortedItems,
      timestamp: newTimestamp,
    });
  }

  onItemRemove(index) {
    const { onSortingChange } = this.props;
    const { sortedItems } = this.state;
    const newSortedItems = [
      ...sortedItems.slice(0, index),
      ...sortedItems.slice(index + 1),
    ];
    this.setState({
      sortedItems: newSortedItems,
    });
    onSortingChange({
      sortedItems: newSortedItems,
    });
  }

  render() {
    const {
      items,
      itemComponent,
      onSortingChange,
      dragDisabled,
      id,
      classes,
      ...otherProps
    } = this.props;
    const { sortedItems, dragged, timestamp } = this.state;
    const ItemComponent = this.sortableItemComponent;
    return (
      <div className={classes.root} id={id}>
        {sortedItems.map((sortedItem, index) => {
          const currentItem = items.find(item => item.ID === sortedItem.ID);
          return (
            <ItemComponent
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              index={index}
              {...currentItem}
              {...sortedItem}
              {...otherProps}
              {...(sortedItems.length > 1 && !dragDisabled)
                ? {
                  boundsSelector: `#${id}`,
                  onStartDrag: this.onFieldDragStart,
                  onDrag: this.onFieldDrag,
                  onStopDrag: this.onFieldDragStop,
                  onDraggableDataChange: this.onDraggableDataChange,
                  withTransition: dragged,
                  timestamp,
                }
                : {
                  dragDisabled: true,
                }}
              onRemove={() => {
                if (!dragDisabled) {
                  this.onItemRemove(index);
                }
              }}
            />
          );
        })}
      </div>
    );
  }
}

SortableList.propTypes = {
  id: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  itemComponent: PropTypes.func.isRequired,
  onSortingChange: PropTypes.func,
  dragDisabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

SortableList.defaultProps = {
  rootRef: null,
  dropActive: false,
  onSortingChange: () => {},
  dragDisabled: false,
};

export default withStyles(styles)(SortableList);



// WEBPACK FOOTER //
// ./src/components/common/SortableList/SortableList.js